import AddRounded from '@mui/icons-material/AddRounded';
import { Button } from '@src/common/components/button/Button';
import { css } from '@src/common/styles/Styles';

type Props = {
  onClick?: () => void;
  disabled?: boolean;
  label: string;
};

export const AddButton = ({ onClick, disabled, label }: Props) => {
  return (
    <Button
      className={addButton}
      disabled={disabled}
      type="submit"
      variant="contained"
      startIcon={<AddRounded />}
      onClick={onClick}
    >
      {label}
    </Button>
  );
};

const addButton = css({
  borderRadius: '100px',
});
